<section class="mb-4 shadow border bg-white rounded-3 overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <i class="me-2 fa-solid fa-wallet" aria-hidden="true"></i>
    <h6 class="m-0">Портфейл</h6>
  </header>
  <ul class="m-0 list-unstyled">
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Текущ баланс:</span>
        <strong
          [ngClass]="profile.currentBalance === 0 ? 'text-secondary' : profile.currentBalance > 0 ? 'text-success' : 'text-danger'">
          <span>{{ profile.currentBalance }} лв.</span>
        </strong>
      </div>
    </li>
  </ul>
  <footer class="bg-light p-3">
    <div class="row g-3 justify-content-end">
      <div class="col-12 col-sm-6 col-md-5 col-xl-4">
        <button class="w-100 btn btn-nz-primary"
                (click)="onOpenPaymentModal()">
          <i class="fa-solid fa-plus-circle"></i>
          <span class="ms-2">Захранване на сметка</span>
        </button>
      </div>
    </div>
  </footer>
</section>
@if (!loading) {
  @if (invoices.length > 0) {
    <section class="my-5">
      <h6 class="text-primary-emphasis mb-3">
        <i class="me-2 fa-solid fa-credit-card" aria-hidden="true"></i>
        <span>Извършени плащания</span>
      </h6>
      <ul class="list-unstyled" nzRestoreScrollPosition>
        @for (invoice of invoices; track invoice.invoiceId) {
          <li class="my-3 border shadow-sm rounded-3 bg-white overflow-hidden">
            <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
              <h6 class="m-0">Референтен номер <strong>{{ invoice.invoiceNumber }}</strong></h6>
            </header>
            <div class="p-3 d-flex justify-content-between align-items-center">
              <div>
                <small class="text-muted">Сума:</small>
                <strong class="d-block">{{ invoice.amount.toFixed(2) }} лв.</strong>
              </div>
              <div>
                <small class="text-muted">Дата:</small>
                <strong class="d-block">{{ invoice.dateTime | date:'dd.MM.yyyy г.' }}</strong>
              </div>
            </div>
          </li>
        }
      </ul>
    </section>
  }
} @else {
  <section class="my-5">
    <div class="text-center">
      <h1>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
